export default __webpack_public_path__ + "static/media/TheElements _19.7992b701.png";